export const SET_EDIT_SCHEDULE_PAGINATED_REPORTS_LOADED = "SET_EDIT_SCHEDULE_PAGINATED_REPORTS_LOADED";

export const setEditSchedulePaginatedReportsLoaded = (editSchedulePaginatedReportsLoaded: boolean) => {
    return {
        editSchedulePaginatedReportsLoaded,
        type: SET_EDIT_SCHEDULE_PAGINATED_REPORTS_LOADED
    };
};
